// extracted by mini-css-extract-plugin
module.exports = {"icon-small":"index_icon-small_3iWIp","force-agreement-view":"index_force-agreement-view_1FO9b"};